import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-upload-duplicated',
    templateUrl: './dialog-upload-duplicated.component.html',
    styleUrls: ['./dialog-upload-duplicated.component.scss'],
    standalone: false
})
export class DialogUploadDuplicatedComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { document_name?: string }) {}
}
